import type { FC } from "react";
import type React from "react";
import { Box, Container } from "@mui/material";

type Props = {
  children: React.ReactNode;
};

const AuthFormGrid: FC<Props> = ({ children }) => (
  <Container
    component="main"
    maxWidth="xs"
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "none",
    }}
  >
    <Box display="flex" flexDirection="column" alignItems="center" p={2}>
      {children}
    </Box>
  </Container>
);

export default AuthFormGrid;
